@if (transportDetails) {
  <div class="planned-assignment-list-entry" [ngClass]="{'selected' : selected}" matRipple>
    <sc-flex>
      <app-transport-scope-icon [scope]="transportDetails.scope"></app-transport-scope-icon>
      <div class="title">{{transportDetails.identifyingNumberplate}}</div>
      <sc-content-spacer grow></sc-content-spacer>
      <div class="duration">{{transportDetails.processing.processingTime}}</div>
    </sc-flex>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-flex>
      <div class="carrier">{{transportDetails.masterdata.carrier}}</div>
    </sc-flex>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-flex>
      @if (transportDetails?.timing.planningDate) {
        <sc-icon iconClass="fa-calendar"></sc-icon>
        <sc-content-spacer [half]="true"></sc-content-spacer>
        {{transportDetails?.timing.planningDate | timestamp }}
        @if (transportDetails?.timing.timeSlotDelay) {
          (+{{transportDetails?.timing.timeSlotDelay}})
        }
      }
      <sc-content-spacer grow></sc-content-spacer>
      @if (transportDetails.masterdata.important) {
        <div class="status-icon">
          <sc-icon iconClass="fa-exclamation"></sc-icon>
        </div>
      }
      @if (transportDetails.masterdata.dangerousGoods) {
        <div class="status-icon">
          <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
        </div>
      }
      @if (transportDetails.processing.pendingTaskState !== TransportTaskStatus.NONE) {
        <div class="status-icon">
          <app-task-state-icon [state]="transportDetails.processing.pendingTaskState"></app-task-state-icon>
        </div>
      }
      @if (transportDetails.masterdata.urgent) {
        <div class="status-icon">
          <sc-icon iconClass="fa-truck-fast"></sc-icon>
        </div>
      }
      @if (transportDetails.processing.inUmbrueckung) {
        <div class="status-icon">
          <sc-icon iconClass="fa-random"></sc-icon>
        </div>
      }
    </sc-flex>
  </div>
}
